export default {
  Title: 'Funnel Analytics Dashboard',
  Subtitle: 'View metrics and trends',
  VsPrior: 'vs. Prior 7 days',
  Weekly: 'Weekly',
  Daily: 'Daily',
  KeyMetricsSection: 'KEY METRICS - PAST 7 DAYS VS. PRIOR 7 DAYS',
  FunnelBreakdownSection: 'FUNNEL BREAKDOWN',
  CohortSection: 'COHORT CONVERSION RATES',
  KeyMetrics: {
    Leads: 'LEADS',
    MeetGreet: 'MEET & GREETS',
    Starts: 'STARTS',
    Previous: 'Prev: #{count}',
    LoadError: 'Unable to load key metrics right now.',
  },
  FunnelBreakdown: {
    StageDistribution: 'Stage distribution',
    StageDistributionSubtitle: 'Leads currently in each stage',
    StageDetail: 'Stage detail',
    StageDetailSubtitle: 'Current vs. previous period',
    Stage: 'STAGE',
    Now: 'NOW',
    Prev: 'PREV.',
    Delta: '+/-',
  },
  Cohort: {
    AllMetrics: 'All Metrics',
    Stages: {
      LEAD: 'Lead',
      DETAILS_NEEDED: 'Detail Needed',
      CG_SEARCH: 'CG Search Queued',
      CG_SEARCH_ACTIVE: 'CG Search Active',
      CG_PROFILE_SENT: 'CG Profile Sent',
      MEET_GREET: 'M&G Booked',
      ACTIVE: 'Active',
      STALLED: 'Stalled',
      CLOSED_LOST: 'Closed Lost',
    },
  },
};
